import React from "react"
import { styled } from "@mui/material/styles"
import _ from "lodash"

const CategorySelectEl = styled('select')(({ size }) => ({
  width: '100%',
  height: size ? `${parseInt(size) * 23}px` : 'inherit',
}));

const CategorySelectContainer = styled('div')`
  width: 100%;
`

export default class CategorySelect extends React.Component {
  static defaultProps = {
    selectedCategoryId: "",
    categorySelectSize: 6,
  }

  handleCategorySelect = (e) => {
    const { categories } = this.props
    const categoryId = e.target.value
    this.props.categorySelectCallback(categoryId)
  }

  renderMainCategories = () => {
    const { categories, selectedCategoryId } = this.props

    const categoriesArray = Object.values(categories)
    const mainCategories = categoriesArray.filter((c) => c.ancestry_depth === 0)
    const subCategories = categoriesArray.filter((c) => c.ancestry_depth === 1)
    const sortedMainCategories = _.sortBy(mainCategories, [
      function (c) {
        return c.name
      },
    ])
    return (
      <>
        {sortedMainCategories.map((category) => {
          const subCategoryIdsOfCategory = subCategories
            .filter((c) => c.ancestry == category.id)
            .map((c) => c.id)
          const isSelected =
            category.id == selectedCategoryId ||
            subCategoryIdsOfCategory.includes(selectedCategoryId)
          return (
            <option value={category.id} key={category.id} selected={isSelected}>
              {_.capitalize(category.name)}
            </option>
          )
        })}
      </>
    )
  }

  renderSubCategories = () => {
    const { categories, selectedCategoryId } = this.props
    const categoriesArray = Object.values(categories)
    if (!selectedCategoryId) {
      return null
    }
    const selectedCategory = categories[selectedCategoryId]
    let subCategories
    if (selectedCategory.ancestry_depth == 0) {
      subCategories = categoriesArray.filter(
        (c) => c.ancestry == selectedCategory.id
      )
    } else {
      subCategories = categoriesArray.filter(
        (c) => c.ancestry == selectedCategory.ancestry
      )
    }
    const sortedSubCategories = _.sortBy(subCategories, [
      function (c) {
        return c.name
      },
    ])
    return (
      <>
        {sortedSubCategories.map((category) => {
          const isSelected = category.id == selectedCategoryId
          return (
            <option value={category.id} key={category.id} selected={isSelected}>
              {_.capitalize(category.name)}
            </option>
          )
        })}
      </>
    )
  }

  render() {
    const { categories, selectedCategoryId, categorySelectSize } = this.props

    const selectedCategory = categories[selectedCategoryId]
    return (
      <CategorySelectContainer>
        <div className="row">
          <div className="col s6">
            <label>Type</label>
            <CategorySelectEl
              size={categorySelectSize}
              onChange={this.handleCategorySelect}
            >
              {this.renderMainCategories()}
            </CategorySelectEl>
          </div>
          <div className="col s6">
            <label>Subtype</label>
            <CategorySelectEl
              size={categorySelectSize}
              onChange={this.handleCategorySelect}
            >
              {this.renderSubCategories()}
            </CategorySelectEl>
          </div>
        </div>
      </CategorySelectContainer>
    )
  }
}
